import React from "react";

const CounterSection = () => {
  return (
    <section className='counter'>
      <div className='container container-lg'>
        <div className='row justify-content-center'>
          <div className='col-xxl-8'>
            <div className='bg-neutral-600 rounded-16 px-xxl-5 px-xl-4'>
              <div className='row gy-lg-0 gy-4 line-wrapper'>
                <div className='col-lg-4 col-sm-6 col-xs-6'>
                  <div className='counter-item text-center py-100 px-8'>
                    <h3 className='text-main-600 counter mb-8 fw-semibold'>
                      18+ Years
                    </h3>
                    <p className='text-white text-xl font-heading-two fw-semibold'>
                      Fun Card was established 2003 in Wisconsin / Michigan
                    </p>
                  </div>
                </div>
                <div className='col-lg-4 col-sm-6 col-xs-6'>
                  <div className='counter-item text-center py-100 px-8'>
                    <h3 className='text-main-600 counter mb-8 fw-semibold'>
                      10,000+ Users
                    </h3>
                    <p className='text-white text-xl font-heading-two fw-semibold'>
                      History of Satisfied Customers Redeeming Coupons with <span>Fun Card</span>
                    </p>
                  </div>
                </div>
                <div className='col-lg-4 col-sm-6 col-xs-6'>
                  <div className='counter-item text-center py-100 px-8'>
                    <h3 className='text-main-600 counter mb-8 fw-semibold'>
                      600+ Businesses
                    </h3>
                    <p className='text-white text-xl font-heading-two fw-semibold'>
                      Have trusted the Fun Card Coupons for nearly 2 decades
                    </p>
                  </div>
                </div>
                {/* <div className='col-lg-3 col-sm-6 col-xs-6'>
                  <div className='counter-item text-center py-100 px-8'>
                    <h3 className='text-main-600 counter mb-8 fw-semibold'>
                      50,000+ <span>Fun Cards</span> 
                    </h3>
                    <p className='text-white text-xl font-heading-two fw-semibold'>
                      Sold in our record selling year
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
